import apiAdapterCoffeeWeb from '../Services/apiAdapterCoffeeWeb'
import { ROUTE_STRINGS } from './Constants'

export const coffeewebSetLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}
export const coffeewebGetLocal = (key) => {
  const value = localStorage.getItem(key)

  return JSON.parse(value)
}
export const coffeewebClearLocal = () => {
  localStorage.clear()
}

export const updateUserDetails = async () => {
  const userDetails = getLocalUserDetails()
  const response = await apiAdapterCoffeeWeb.getuserbyuserid(userDetails?.id)

  setLocalWithUserDetails(response.data)
}

export const redirectToHome = (history) => {
  history.push({
    pathname: ROUTE_STRINGS.login
  })
}

export const coffeewebStorageKeys = {
  authToken: 'authToken',
  userDetails: 'userDetails',
  appSettings: 'appSettings',
  singleSignOn: 'singleSignOn',
  languageId: 'languageId',
  isLoggedIn: 'isLoggedIn',
  reconcileTableColumns: 'reconcileTableColumns',
  paymentReportTableColumns: 'paymentReportTableColumns',
  subscriptionPaymentReportTableColumns: 'subscriptionPaymentReportTableColumns',
  loginOtpFlowVersion: 'loginOtpFlowVersion',
  jwtToken: 'jwtToken'
}

const getLocalStorage = {
  getLocalUserDetails() {
    return coffeewebGetLocal(coffeewebStorageKeys.userDetails)
  },
  getLocalAuthToken() {
    return coffeewebGetLocal(coffeewebStorageKeys.authToken)
  },
  getLocalAppSettings() {
    return coffeewebGetLocal(coffeewebStorageKeys.appSettings)
  },
  getLocalLoggedInStatus() {
    return coffeewebGetLocal(coffeewebStorageKeys.isLoggedIn)
  },
  getLocalReconcileTableColumns() {
    return coffeewebGetLocal(coffeewebStorageKeys.reconcileTableColumns)
  },
  getLocalPaymentReportTableColumns() {
    return coffeewebGetLocal(coffeewebStorageKeys.paymentReportTableColumns)
  },
  getLocalSubscriptionPaymentReportTableColumns() {
    return coffeewebGetLocal(coffeewebStorageKeys.subscriptionPaymentReportTableColumns)
  },

  getLoginOtpFlowVersion() {
    return coffeewebGetLocal(coffeewebStorageKeys.loginOtpFlowVersion)
  },
  getLocalJwtToken() {
    return coffeewebGetLocal(coffeewebStorageKeys.jwtToken)
  }
}

const setLocalStorage = {
  setLocalWithUserDetails(userData) {
    coffeewebSetLocal(coffeewebStorageKeys.userDetails, userData)
  },
  setLocalWithAuthToken(userAuthToken) {
    coffeewebSetLocal(coffeewebStorageKeys.authToken, userAuthToken)
  },
  setLocalWithAppSettings(appSettings) {
    coffeewebSetLocal(coffeewebStorageKeys.appSettings, appSettings)
  },
  setLocalWithLoggedInStatus(userLoginStatus) {
    coffeewebSetLocal(coffeewebStorageKeys.isLoggedIn, userLoginStatus)
  },
  setLocalWithReconcileTableColumns(availableColumns) {
    coffeewebSetLocal(coffeewebStorageKeys.reconcileTableColumns, availableColumns)
  },
  setLocalWithPaymentReportTableColumns(availableColumns) {
    coffeewebSetLocal(coffeewebStorageKeys.paymentReportTableColumns, availableColumns)
  },
  setLocalWithSubscriptionPaymentReportTableColumns(availableColumns) {
    coffeewebSetLocal(coffeewebStorageKeys.subscriptionPaymentReportTableColumns, availableColumns)
  },
  setLoginOtpFlowVersion(loginOtpVersion) {
    coffeewebSetLocal(coffeewebStorageKeys.loginOtpFlowVersion, loginOtpVersion)
  },
  setLocalWithjwtToken(token) {
    coffeewebSetLocal(coffeewebStorageKeys.jwtToken, token)
  }
}

export const { getLocalUserDetails, getLocalAuthToken, getLocalAppSettings, getLocalLoggedInStatus, getLocalReconcileTableColumns, getLocalPaymentReportTableColumns, getLocalSubscriptionPaymentReportTableColumns, getLoginOtpFlowVersion, getLocalJwtToken } = getLocalStorage
export const { setLocalWithUserDetails, setLocalWithAuthToken, setLocalWithAppSettings, setLocalWithLoggedInStatus, setLocalWithReconcileTableColumns, setLocalWithPaymentReportTableColumns, setLocalWithSubscriptionPaymentReportTableColumns, setLoginOtpFlowVersion, setLocalWithjwtToken } = setLocalStorage
